export default {
    locale: 'en-IE',
    dismissAlertText: 'Close'
};
